import { call, put, takeLatest } from "redux-saga/effects";
import { OP } from "../../constant";
import errorMessage from "../../utils/error.json";
import { doListFolderLogs, doListLogs, doViewLog } from "../../service/logs";

function* listLogsTask(action) {
  try {
    yield put({
      type: OP.LIST_LOGS_LOADING,
    });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doListLogs,
      payload.token,
      payload.data,
    );

    if (res.status === 200) {
      yield put({
        type: OP.LIST_LOGS_SUCCESS,
        payload: decoded_data.data,
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];

      yield put({
        type: OP.LIST_LOGS_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.LIST_LOGS_FAILURE,
      payload: errMsg,
    });
  }
}

function* listFolderLogsTask(action) {
  try {
    yield put({
      type: OP.LIST_FOLDER_LOGS_LOADING,
    });

    const { payload } = action;

    const { res, decoded_data } = yield call(
      doListFolderLogs,
      payload.token,
      payload.data,
    );

    if (res.status === 200) {
      yield put({
        type: OP.LIST_FOLDER_LOGS_SUCCESS,
        payload: decoded_data.data,
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];

      yield put({
        type: OP.LIST_FOLDER_LOGS_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.LIST_FOLDER_LOGS_FAILURE,
      payload: errMsg,
    });
  }
}

function* viewLogTask(action) {
  try {
    yield put({ type: OP.VIEW_LOG_LOADING });

    const { payload } = action;

    // API call
    const { res, decoded_data } = yield call(
      doViewLog,
      payload.token,
      payload.data,
    );

    if (res.status === 200) {
      yield put({
        type: OP.VIEW_LOG_SUCCESS,
        payload: decoded_data.data, // log content
      });
    } else {
      const errMsg = res.data
        ? errorMessage[res.data.code]
        : errorMessage[1000];

      yield put({
        type: OP.VIEW_LOG_FAILURE,
        payload: errMsg,
      });
    }
  } catch (e) {
    const errMsg = e.data ? errorMessage[e.code] : errorMessage[4000];
    yield put({
      type: OP.VIEW_LOG_FAILURE,
      payload: errMsg,
    });
  }
}

function* logsSaga() {
  yield takeLatest(OP.LIST_LOGS_REQUEST, listLogsTask);
  yield takeLatest(OP.LIST_FOLDER_LOGS_REQUEST, listFolderLogsTask);
  yield takeLatest(OP.VIEW_LOG_REQUEST, viewLogTask);
}

export default logsSaga;
